import {
    SET_FINGERPRINT,
    SET_KNOWN_HOSTS,
    SET_AUTO_APPROVE_PLAINTEXT_PASSWORD,
    SET_REMOTE_CONFIG_JSON,
} from "../actions/action-types";

const defaultKnownHosts = [
    {
        url: "https://free.idcontrol.pw/server",
        verify_key: "00c4b8760b6cba26f3acc26bc5123fa626e207cf6cff6659428a7cf1de167dea",
    },
];

function persistent(
    state = {
        knownHosts: defaultKnownHosts,
        autoApproveLdap: {},
        remoteConfigWebClientUrl: null,
        remoteConfigJson: null,
        fingerprint: null,
    },
    action
) {
    switch (action.type) {
        case SET_KNOWN_HOSTS:
            return Object.assign({}, state, {
                knownHosts: action.knownHosts,
            });
        case SET_AUTO_APPROVE_PLAINTEXT_PASSWORD:
            return Object.assign({}, state, {
                autoApproveLdap: action.autoApproveLdap,
            });
        case SET_REMOTE_CONFIG_JSON:
            return Object.assign({}, state, {
                remoteConfigWebClientUrl: action.remoteConfigWebClientUrl,
                remoteConfigJson: action.remoteConfigJson,
            });
        case SET_FINGERPRINT:
            return Object.assign({}, state, {
                fingerprint: action.fingerprint,
            });
        default:
            return state;
    }
}

export default persistent;
